// See https://github.com/date-fns/date-fns/issues?q=%22no-duplicate%22
import { format, formatDistanceToNow, parseJSON } from 'date-fns';
import { de, enUS as en, es, fr, it, pt, ro, ru } from 'date-fns/locale';

import i18n from '../i18n';
import { SupportedLocalesCodes } from '../supportedLocales';

export type DateTimeLocales = { [T in SupportedLocalesCodes]: typeof en };

const locales: DateTimeLocales = {
  en,
  fr,
  es,
  de,
  pt,
  it,
  ru,
  ro,
};

export function formatFromNow(...args: Parameters<typeof formatDistanceToNow>) {
  const locale =
    locales[i18n.locale as SupportedLocalesCodes] ??
    locales[i18n.defaultLocale as SupportedLocalesCodes];

  return formatDistanceToNow(args[0], {
    locale,
    ...args[1],
  });
}

/**
 * Parse date from SQL UTC format
 *
 * Example: 2022-01-19 10:54:00
 */
export function dateFromSQLUTC(SQLUTCDate: string) {
  return parseJSON(SQLUTCDate);
}

export function formatForAlarm(date: Date) {
  const locale =
    locales[i18n.locale as SupportedLocalesCodes] ??
    locales[i18n.defaultLocale as SupportedLocalesCodes];

  return format(date, 'PPPP', { locale: locale });
}

/**
 * get locale string for native date/time pickers
 * maps app locale to platform locale format (e.g., 'fr' -> 'fr-FR')
 */
export function getLocaleString() {
  const currentLocale = i18n.locale as SupportedLocalesCodes;
  const localeMap: { [key in SupportedLocalesCodes]: string } = {
    en: 'en-US',
    fr: 'fr-FR',
    es: 'es-ES',
    de: 'de-DE',
    pt: 'pt-PT',
    it: 'it-IT',
    ru: 'ru-RU',
    ro: 'ro-RO',
  };
  return localeMap[currentLocale] || 'en-US';
}

/**
 * format date for episode card published date
 * returns format like "7 juillet 2025" for french, "july 7, 2025" for english
 */
export function formatEpisodeDate(date: Date | string) {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const localeCode = getLocaleString();

  return dateObj.toLocaleDateString(localeCode, {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
